export default "__VITE_ASSET__sOS99NQY__"